<cache-date></cache-date>

<period></period>

<br />

<div class="row ul-margin-bottom">
	<div class="col-md-12">
		<nav class="nav nav-pills">
			<a [class]="langTab == 'ru' ? 'period-tab text-sm-center nav-link active' : 'period-tab text-sm-center nav-link'" [routerLink]="['/']" [queryParams]="{period: filter.filterParams.period, langTab: 'ru'}" [attr.tab]="'ru'">ru</a>
			<a [class]="langTab == 'en' ? 'period-tab text-sm-center nav-link active' : 'period-tab text-sm-center nav-link'" [routerLink]="['/']" [queryParams]="{period: filter.filterParams.period, langTab: 'en'}" [attr.tab]="'en'">en</a>
		</nav>
	</div>
</div>

<br />

<div class="btn-group" role="group" *ngIf="filter.filterParams.period == 'day'">
	<button type="button" [class]="chartPeriod == '30days' ? 'btn btn-light active' : 'btn btn-light'" (click)="onFilterChange('30days')">30 days</button>
	<button type="button" [class]="chartPeriod == 'all' ? 'btn btn-light active' : 'btn btn-light'" (click)="onFilterChange('all')">all</button>
</div>

<div class="row">
	<div class="col-md-12">
		<chart [data]="firstChart.data" [options]="firstChart.options" (onFilterChange)="updateData($event, 'firstChart')" [sextant]="'chart1'" [url]="filter.currentUrl"></chart>
	</div>
</div>

<div class="row">
	<div class="col-md-12">
		<chart [data]="secondChart.data" [options]="secondChart.options" (onFilterChange)="updateData($event, 'secondChart')" [sextant]="'chart2'" [url]="filter.currentUrl"></chart>
	</div>
</div>

<br />

<ngb-pagination [extlinks]="links" [collectionSize]="totalPages" [maxSize]="10" [pageSize]="1" [(page)]="currentPage" [boundaryLinks]="true" (pageChange)="onPageChange()" *ngIf="!paginationLoader && pages && pages.length > 1"></ngb-pagination>

<table class="table table-bordered table-nonfluid">
	<thead>
	<tr>
		<th>{{ 'adminstat.common.Date' | translate }}</th>
		<th>{{ 'adminstat.yandex.tariffVisitCount' | translate }}</th>
		<th>{{ 'adminstat.yandex.paymentVisitCount' | translate }}</th>
		<th>{{ 'adminstat.yandex.tariffAndPaymentConversion' | translate }}</th>
		<th>{{ 'adminstat.yandex.paidCount' | translate }}</th>
		<th>{{ 'adminstat.yandex.paidAndPaymentConversion' | translate }}</th>
	</tr>
	</thead>
	<tbody>
	<tr *ngFor="let row of stats">
		<td>{{row.timestamp | dateFormat:'DD.MM.YYYY'}}</td>
		<td>{{row.tariffVisitCount}}</td>
		<td>{{row.paymentVisitCount}}</td>
		<td>{{row.tariffAndPaymentConversion}}</td>
		<td>{{row.paidCount}}</td>
		<td>{{row.paidAndPaymentConversion}}</td>
	</tr>
	</tbody>
</table>
